import { Typography } from '@mui/material';

interface IOptionLabel {
  text: string;
  hasError?: boolean;
}

export const OptionLabel = ({ text, hasError }: IOptionLabel) => {
  return (
    <Typography
      sx={{
        fontFamily: 'Inter',
        fontSize: '14px',
        fontWeight: '400',
        color: hasError ? 'red' : 'black',
      }}
    >
      {text}
    </Typography>
  );
};
